import { useQuery } from "react-query";
import { zodParseWithDetailedLog } from "src/api/apiErrorLogs";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { isQueryReady } from "src/api/axiosClient/utils";
import { CompanySchema } from "./useGetOneOrganization";

export const getSupplierKey = "getSupplier" as const;

type Options = {
    supplierId?: string;
    enabled?: boolean;
};

export const useGetSupplier = (options: Options) => {
    const { supplierId, enabled = true } = options;

    const isEnabled = supplierId !== undefined && enabled;
    const query = useQuery({
        queryKey: [getSupplierKey, supplierId],
        cacheTime: 0,
        enabled: isEnabled,
        queryFn: () => loggedInApiCall.get(`/api/suppliers/${supplierId}`),
        select: (response) =>
            zodParseWithDetailedLog(response.data, CompanySchema, {
                operation: "GET",
                endpoint: "/suppliers/:id",
            }),
    });

    return {
        company: query.data,
        isReady: isQueryReady(query, isEnabled),
        ...query,
    };
};
